import { Button } from '@arco-design/web-react';
import { IconPlus } from '@arco-design/web-react/icon';

import styles from './VolumeEmptyActionPanel.module.less';

export interface VolumeEmptyActionItem {
  key?: string;
  title: string;
  /** 标题下方说明文案 */
  description?: string;
  onClick: () => void;
}

interface VolumeEmptyActionRowProps extends VolumeEmptyActionItem {
  className?: string;
}

/** 灰色操作行：左侧标题（可选描述）+ 右侧添加按钮 */
function VolumeEmptyActionRow({ title, description, onClick, className }: VolumeEmptyActionRowProps) {
  return (
    <div className={[styles.row, className].filter(Boolean).join(' ')}>
      <div className={styles.text}>
        <span className={styles.title}>{title}</span>
        {description ? <span className={styles.description}>{description}</span> : null}
      </div>
      <Button type="primary" icon={<IconPlus />} onClick={onClick} />
    </div>
  );
}

interface VolumeEmptyActionPanelProps {
  items: VolumeEmptyActionItem[];
  className?: string;
}

/** 无数据操作区：虚线外框 + 多行灰色操作条 */
export function VolumeEmptyActionPanel({ items, className }: VolumeEmptyActionPanelProps) {
  if (!items.length) return null;

  return (
    <div className={[styles.panel, className].filter(Boolean).join(' ')}>
      {items.map((item) => (
        <VolumeEmptyActionRow key={item.key ?? item.title} title={item.title} description={item.description} onClick={item.onClick} />
      ))}
    </div>
  );
}
